module.exports = __webpack_public_path__ + "media/images/pc/visit_reservations_enpou/flow_01-9be4ca5690930edc7623efd7052666d7.jpg";